/**
 * Trailing print-variant parentheticals — keep behavior aligned with
 * `api/_shared/cardNameNormalize.js` (`sanitizeCardName`).
 * Handles ASCII or fullwidth parens (some API / OCR strings).
 */
const PRINT_SUFFIX_RE =
  /\s*[（(]\s*(Alternate Art|Overnumbered|Signed|Signature|Ultimate|Metal Deluxe|Metal|Champion|Top 8|Summoner Circle|Launch Exclusive|Chinese Unleashed Regional Open)\s*[）)]\s*$/i;

/** Label inside the trailing print suffix, e.g. "Alternate Art", or null. */
export function trailingPrintSuffix(raw: string): string | null {
  const match = String(raw ?? '').match(PRINT_SUFFIX_RE);
  return match?.[1] ?? null;
}

/** Remove trailing print suffixes (trim between passes). */
export function stripTrailingPrintSuffix(raw: string): string {
  let s = String(raw ?? '').trim();
  let prev: string;
  do {
    prev = s;
    s = s.replace(PRINT_SUFFIX_RE, '').trim();
  } while (s !== prev);
  return s;
}

/** Match against a base card title when the query includes a print suffix. */
export function searchQueryForNameMatch(q: string): string {
  const t = q.trim();
  const stripped = stripTrailingPrintSuffix(t);
  return stripped.length > 0 ? stripped : t;
}
